import MenuSection from './../components/MenuSection.jsx';

const Menus = () => {
  return (
    <MenuSection />
  )
}

export default Menus